import { message } from 'antd';
import { client } from '../../../actions';
import { authHeader } from '../../../helpers/auth-header';

const sendCodeToAddEmail = async (email) => {
  try {
    const response = await client.post(
      '/Profile/add_email',
      {},
      {
        headers: authHeader(),
        params: { email },
      }
    );
    if (response.data.result === 'Error') {
      message.error(response.data.message, 5);
    }
  } catch (e) {
    console.error(e);
    message.error('Произошла ошибка', 5);
  }
};

export default sendCodeToAddEmail;
